import React, { useState } from "react";
import { Link } from "react-router-dom";
import { StyledFormWrapper } from "../../../styled-components/StyledFormWrapper.style";
import { LogoSis } from "../../../svg/index";
import { DynamicInput } from "../../../components/DynamicInput";
import { ButtonOutline } from "../../../components/ButtonOutline";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { Footer } from "../../../components/Footer";

export const LoginRecover = () => {
    const [success, setSuccess] = useState(false);

    let content = !success ? (
        <StyledFormWrapper>
            <LogoSis width={"340"} />

            <h2 className="info font-weight-normal mt-4 mb-3">
                <b>Para recuperar sua senha</b>, insira seu nome de usuário.
            </h2>

            <StyledForm direction={"column"}>
                <div className="position-relative mt-3 mb-4">
                    <DynamicInput
                        type={"text"}
                        placeholder={"Ex Bruno..."}
                        label={"Nome de usuário"}
                        name={"user"}
                    />
                </div>

                <div className="d-flex justify-content-between align-items-center my-3">
                    <div className="w-50">
                        <Link to={"/login"}>
                            <h2 className="info font-weight-normal text-red cursor-pointer">
                                Lembrei minha senha
                            </h2>
                        </Link>
                    </div>

                    <div
                        className="w-50 position-relative"
                        onClick={() => setSuccess(true)}
                    >
                        <ButtonOutline
                            outlineColor={"#0675BD"}
                            backgroundColor={"#0675BD"}
                            color={"#fff"}
                            text={"Recuperar"}
                        />
                    </div>
                </div>
            </StyledForm>
        </StyledFormWrapper>
    ) : (
        <StyledFormWrapper>
            <LogoSis width={"340"} />

            <h2 className="info font-weight-normal mt-4 mb-4">
                <b>Sucesso</b>, foi enviado um e-mail para sua caixa de entrada,
                siga as instruções para recuperar seu acesso.
            </h2>

            <StyledForm direction={"column"}>
                <div className="position-relative">
                    <Link to={"/login"}>
                        <ButtonOutline
                            outlineColor={"#0675BD"}
                            backgroundColor={"#0675BD"}
                            color={"#fff"}
                            text={"Voltar para o login"}
                        />
                    </Link>
                </div>
            </StyledForm>
        </StyledFormWrapper>
    );

    return (
        <div className="position-relative">
            <section className="bg-lightgrey d-flex flex-column justify-content-center align-items-center h-88vh">
                {content}
            </section>

        </div>
    );
};
